<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
    @input="dialogStateChanged"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        light
        v-bind="attrs"
        :small="small"
        v-on="on"
      >
        <v-icon :small="small" class="mr-1">mdi-share-variant</v-icon>
        {{label}}
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Share {{decisionName}} with...</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Email*"
                required
                v-model="shareEmail"
                :error-messages="emailErrors"
                @input="$v.shareEmail.$touch()"
                @blur="$v.shareEmail.$touch()"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              This user will be able to: Send messages, add pros and cons, shortlist options, vote.
            </v-col>
            <v-col cols="12">
              Optional Permisions:
              <v-checkbox
                v-model="canAddOptions"
                label="Can add their own options"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false" :disabled="shareInProgress">Cancel</v-btn>
        <v-btn color="primary" :disabled="$v.shareEmail.$invalid || shareInProgress" :loading="shareInProgress" @click="handleShare">Share</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Constants from '../constants.json'
// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'
// Load the auth feature into the firebase namespace.
import 'firebase/auth'
import axios from 'axios'

// vuelidate
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'DecisionSharingDialog',
  mixins: [validationMixin],
  validations: {
    shareEmail: { required, email }
  },
  props: {
    decisionName: String,
    decisionId: String,
    label: {
      type: String,
      default: 'Share'
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    emailErrors () {
      const errors = []
      if (!this.$v.shareEmail.$dirty) return errors
      !this.$v.shareEmail.email && errors.push('Must be valid email address')

      if (this.emailNotFound) {
        errors.push('Could not find a user with that email address')
      }
      return errors
    }
  },
  data () {
    return {
      dialog: false,
      shareEmail: null,
      canAddOptions: true,
      shareInProgress: false,
      emailNotFound: false
    }
  },
  methods: {
    handleShare: async function () {
      const shareMemberData = {email: this.shareEmail, permissions: { canAddOptions: this.canAddOptions }}

      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const postNewDecisionMemberURL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}/members`

      this.emailNotFound = false
      this.shareInProgress = true

      const res = await axios.post(postNewDecisionMemberURL, shareMemberData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      this.shareInProgress = false
      if (res && res.status === 200 && res.data) {

        if (res.data.status === 'success' && res.data.newMemberData) {
          // console.log (`New res ${JSON.stringify(res.data)}`)
          const uidData = {uid: res.data.uid}
          const newMemberData = {...res.data.newMemberData, ...uidData}
          // console.log (`New Member added ${JSON.stringify(newMemberData)}`)
          this.$emit('onShared', newMemberData)
          this.dialog = false

        } else if (res.data.status === 'not found') {
          // console.log ('That user is not in the system')
          // TODO add validation error message
          this.emailNotFound = true
        }

      } else {
        // console.log(`Unexpected response ${JSON.stringify(res)}`)
        alert('Unexpected response creating new decision')
      }

    },
    dialogStateChanged: function () {
      this.shareEmail = null
      this.canAddOptions = true
      this.shareInProgress = false
      this.emailNotFound = false
      this.$v.$reset()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
